import { values } from 'lodash';
import { ReactNode, useEffect, useState } from 'react';

import { PortalCompanyAdminSettings } from '@willow/graphql-iso/src/portal';

import { PortalSelectedLoan } from '../App';
import { FEATURE_FLAG_CONTEXT_DEFAULT } from './FEATURE_FLAG_CONTEXT_DEFAULT';
import { FeatureFlagContext } from './featureFlagContext';

export const FeatureFlagContextProvider = ({
  allCompanySettings,
  selectedLoan,
  children,
}: {
  allCompanySettings: PortalCompanyAdminSettings[] | undefined;
  selectedLoan: PortalSelectedLoan | undefined;
  children: ReactNode;
}) => {
  const [ff_autopaySettings, set_ff_autopaySettings] = useState(FEATURE_FLAG_CONTEXT_DEFAULT.ff_autopaySettings);
  const [ff_applicationsEnabled, set_ff_applicationsEnabled] = useState(
    FEATURE_FLAG_CONTEXT_DEFAULT.ff_applicationsEnabled,
  );
  const [ff_applicationsEnabledSettings, set_ff_applicationsEnabledSettings] = useState(
    FEATURE_FLAG_CONTEXT_DEFAULT.ff_applicationsEnabledSettings,
  );
  const [ff_econsentEnabled, set_ff_econsentEnabled] = useState(FEATURE_FLAG_CONTEXT_DEFAULT.ff_econsentEnabled);

  const [ff_exactPaymentsOnly, set_ff_exactPaymentsOnly] = useState(FEATURE_FLAG_CONTEXT_DEFAULT.ff_exactPaymentsOnly);

  useEffect(() => {
    if (selectedLoan) {
      // eslint-disable-next-line react-hooks/set-state-in-effect -- TODO: pre-existing, surfaced by removing the NamedMemo wrapper; fix in follow-up
      set_ff_autopaySettings(selectedLoan.company.adminSettings.autopayEnabled ?? true);

      const applicationsEnabled =
        selectedLoan.company.adminSettings.applicationsEnabled &&
        values(selectedLoan.company.adminSettings.applicationsEnabledSettings).some((v) => v === true);

      set_ff_applicationsEnabled(applicationsEnabled ?? false);
      set_ff_applicationsEnabledSettings(
        selectedLoan.company.adminSettings.applicationsEnabledSettings ??
          FEATURE_FLAG_CONTEXT_DEFAULT.ff_applicationsEnabledSettings,
      );

      set_ff_econsentEnabled(
        selectedLoan.company.adminSettings.econsentEnabled ?? FEATURE_FLAG_CONTEXT_DEFAULT.ff_econsentEnabled,
      );

      set_ff_exactPaymentsOnly(
        selectedLoan.company.adminSettings.exactPaymentsOnly ?? FEATURE_FLAG_CONTEXT_DEFAULT.ff_exactPaymentsOnly,
      );
    } else if (allCompanySettings) {
      set_ff_econsentEnabled(
        allCompanySettings.some((settings) => settings.econsentEnabled) ??
          FEATURE_FLAG_CONTEXT_DEFAULT.ff_econsentEnabled,
      );
      set_ff_exactPaymentsOnly(
        allCompanySettings.some((settings) => settings.exactPaymentsOnly) ??
          FEATURE_FLAG_CONTEXT_DEFAULT.ff_exactPaymentsOnly,
      );
    }
  }, [allCompanySettings, selectedLoan]);

  return (
    <FeatureFlagContext.Provider
      value={{
        ff_autopaySettings,
        ff_applicationsEnabled,
        ff_applicationsEnabledSettings,
        ff_econsentEnabled,
        ff_exactPaymentsOnly,
      }}
    >
      {children}
    </FeatureFlagContext.Provider>
  );
};
